import React from 'react';
import moment from 'moment';

export function parseOptionsWithUpdatedDate(options) {
  if (!options && options.length) {
    return { key: 0, text: 'None', value: 0 };
  }
  const parsed = options.map(el => ({
    key: el.id,
    text: el.name,
    value: el.id,
    description: (
      <span style={{ fontSize: '12px' }}>
        <span style={{ marginRight: '7px', marginLeft: '7px' }}>{
              moment
              .utc(el.updated_at)
              .local()
              .format('MMM Do YY')
              }
        </span>
        <span>{
              moment
              .utc(el.updated_at)
              .local()
              .format('DD-MM-YYYY HH:mm')
              .split(' ')[1] }
        </span>
      </span>
    )
  }));
  return [...parsed];
}

export function parseProductsNameAndIdOptionsWithUpdateDate(options) {
  if (!options && options.length) {
    return { key: 0, text: 'None', value: 0 };
  }
  const parsed = options.map(el => ({
    key: el.id,
    text: `${el.name} - ${el.id}`,
    value: el.id,
    description: (
      <span style={{ fontSize: '12px' }}>
        <span style={{ marginRight: '7px', marginLeft: '7px' }}>{
              moment
              .utc(el.updated_at)
              .local()
              .format('MMM Do YY')
              }
        </span>
        <span>{
              moment
              .utc(el.updated_at)
              .local()
              .format('DD-MM-YYYY HH:mm')
              .split(' ')[1] }
        </span>
      </span>
    )
  }));
  return [...parsed];
}




// WEBPACK FOOTER //
// ./src/utils/parseResponseToOptions.jsx